import { lazy } from 'react'

export const BreakfastTimeV1 = lazy(() => import('./BreakfastTimeV1'))
